import { FooterComponent } from "./component";
export const Footer = FooterComponent;
